// import jwtDecode from 'jwt-decode';

import { type ILogin, type IToken, type IUser } from '../interface/IAuth';
interface IResponse {
	user: IUser;
	token: IToken;
}

const data = localStorage.getItem('userData');
const user: ILogin = data ? JSON.parse(data) : ({} as ILogin);

const { token, ...userDataProps } = user;

export const userData: IResponse = {
	user: userDataProps,
	// token: token ? jwtDecode(token) : ({} as IToken),
	token: {} as IToken,
};

export const userToken = token;

// export const isLogged = true
export const isLogged = userData.token?.exp ? !(userData?.token?.exp * 1000 < Date.now()) : false;

export const userRole = {
	PRESIDING_OFFICER: 'Presiding Officer',
};

export const PRIMARY_COLOR = '#000';
export const PRIMARY_COLOR_LIGHT = '#F1f1f1';
export const BUTTON_PRIMARY = '#D1D1D1';

export const QUERYBASEURL = `${process.env.REACT_APP_BASE_QUERY}/api/v1/`;
export const COREBASEURL = `${process.env.REACT_APP_BASE_CORE}/api/v1/`;
export const COMMANDBASEURL = `${process.env.REACT_APP_BASE_COMMAND}/api/v1/`;
// In development the KYC service has no CORS headers, so we proxy through
// Vite's dev server at /proxy/kyc → REACT_APP_BASE_KYC. In production set
// REACT_APP_BASE_KYC to a CORS-enabled URL (or a backend proxy).
const isDevHost =
	typeof window !== 'undefined' &&
	(window.location.hostname === 'localhost' ||
		window.location.hostname === '127.0.0.1' ||
		window.location.hostname.endsWith('.local'));
export const KYCBASEURL = isDevHost ? '/proxy/kyc' : (process.env.REACT_APP_BASE_KYC ?? 'https://ielect-kyc.ngrok.app');
export const MEDIAMANAGERURL = 'https://media-manager-ielect.ngrok.app';
// export const QUERYBASEURL = 'http://86.191.120.198:9001/api/v1/';
// export const COREBASEURL = 'http://86.191.120.198:9001/api/v1/';
// export const COMMANDBASEURL = 'http://86.191.120.198:9001/api/v1/';
// export const QUERYBASEURL = 'https://ielect-erms-ms-query.herokuapp.com/api/v1/'
// export const COREBASEURL = 'https://ielect-erms-ms-core.herokuapp.com/api/v1/'
// export const COMMANDBASEURL =
//   'https://ielect-erms-ms-command.herokuapp.com/api/v1/'

export const ABOUT = `<p>Elections are the most fundamental decision any nation makes. The process underscores the constitutional clause that allows for the participation of every adult in the process as enshrined in civic responsibilities. At the same time, participation in elections determines any country's future.</p>  
 
<p>Nation-building is a joint task; any country's economic and political state today reflects its citizens' involvement in the electoral process. For the Nigerian youth in particular, the 2023 elections are about the most fundamental; it will either make or mar the near future, and there should be no room for sitting on the fence.</p>
<p>Won't you instead join hands to change the current reality of our nation where the narration is a tale of woes? Though we have an improved Electoral Act, ensuring the credibility of elections is a collective responsibility, and the way to do so is to get involved in the process.</p> 
<p>Join the forces of light against darkness, and volunteer to be a party agent in your locality while carrying out your civic responsibility and Make Extra Money legitimately. Yes, make extra money legitimately on Election Day by volunteering as a party agent. Two easy steps are required:</p>
<ol>
<li>Click on Register and fill in your full name, email address, phone number and gender.</li>
<li>Select the Pooling unit of your choice around your location.</li>
</ol>`;
